var map = {
	"./project/jem/desktop.svg": "d0fd",
	"./project/jem/mobile.svg": "a53e",
	"./project/jem/tablet.svg": "6f3b",
	"./project/people/baby.svg": "d494",
	"./project/people/baby1.svg": "2e33",
	"./project/people/boy.svg": "3425",
	"./project/people/girl.svg": "c1a5",
	"./project/people/man.svg": "5f96",
	"./project/people/mansenior.svg": "1335",
	"./project/people/woman.svg": "7c70",
	"./project/people/womansenior.svg": "a7b3",
	"./project/ttsh/mobile.svg": "56bc",
	"./template/sample-logo.svg": "2bfb",
	"./template/timeline.svg": "ad84"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";